<template>
  <div>
    <app-title v-if="editModeEnabled" label="DOCUMENTAÇÃO" />

    <app-import-document
      v-if="hasInputAllowed() && editModeEnabled"
      id="docs"
      name="docus"
      class="col-12"
      :model-value="uploadedFileUrls"
      :has-view="false"
      :large-drop-area="true"
      :upload-fn="uploadFn"
      accept="image/*, .pdf, .word"
      :is-loading="loadingUpload"
      @update:modelValue="handleDocumentUpdate"
    />

    <app-list-document
      v-if="editModeEnabled"
      class="col-12"
      :model-value="uploadedFileUrls"
      :type-file="typeFile"
      :readonly-files="readonlyFiles"
      @update:modelValue="handleDocumentUpdate"
    />

    <app-title v-if="editModeEnabled && principalAmountValue > 10000" label="CONTRATO DE CÂMBIO" />

    <app-docusign-list :contract="docusignExchangeContract" title="Contrato de câmbio" />

    <app-import-document
      v-if="hasInputAllowed() && editModeEnabled && principalAmountValue > 10000"
      id="docusign"
      name="docusign"
      class="col-12"
      :model-value="uploadedDocusignFileUrls"
      :has-view="false"
      :large-drop-area="true"
      :upload-fn="uploadFn"
      accept=".pdf"
      :is-loading="loadingUpload"
      @update:modelValue="handleDocusignUpdate"
    />
  </div>
</template>

<script>
import appDocusignList from '@shared/components/shared/docusignList.vue'
import appListDocument from '@shared/components/shared/listDocument.vue'
import { appTitle, appImportDocument } from 'tb-design_system-web'

export default {
  components: {
    appTitle,
    appImportDocument,
    appListDocument,
    appDocusignList
  },
  props: {
    editModeEnabled: {
      type: Boolean,
      default: false
    },
    hasInputAllowed: {
      type: Function,
      required: true
    },
    loadingUpload: {
      type: Boolean,
      default: false
    },
    uploadFn: {
      type: Function,
      required: true
    },
    principalAmountValue: {
      type: [Number, String],
      default: 0
    },
    docusignExchangeContract: {
      type: Object,
      default: () => ({})
    },
    uploadedFileUrls: {
      type: Array,
      default: () => []
    },
    uploadedDocusignFileUrls: {
      type: Array,
      default: () => []
    },
    typeFile: {
      type: Array,
      default: () => []
    },
    readonlyFiles: {
      type: Array,
      default: () => []
    }
  },
  emits: ['document-updated', 'docusign-updated'],
  methods: {
    handleDocumentUpdate(documents) {
      this.$emit('document-updated', documents)
    },
    handleDocusignUpdate(documents) {
      this.$emit('docusign-updated', documents)
    }
  }
}
</script>
